<template>
  <div id="result-detail">
    <!--    <div v-if="isLoading" class="loading">-->
    <!--      <b-spinner type="grow" label="Spinning"></b-spinner>-->
    <!--    </div>-->
    <b-breadcrumb>
      <b-breadcrumb-item text="รายการผลการทดสอบ" @click="goResultPage()" />
      <b-breadcrumb-item :text="data.name + ' AN ' + data.an" active />
    </b-breadcrumb>
    <div id="topic">ผลการทดสอบ</div>
    <div id="sub-topic" class="left">
      LN - {{ items.order.ln }}
      <label
        v-if="parseInt(items.order.status_id) !== 6"
        :class="{
          'text-red': items.order.emergency_level === 1,
          'text-orange':
            items.order.emergency_level === 1
              ? false
              : items.order.urgency_hospital_type !== 'ปกติ',
          'ml-1': true,
        }"
      >
        {{
          items.order.emergency_level === 1
            ? "ด่วนพิเศษ " +
              `${
                items.order.sending_time
                  ? "(" + items.order.sending_time + ")"
                  : ""
              }`
            : items.order.urgency_hospital_type
        }}
      </label>
      <label v-else class="text-red"
        >ยกเลิก ({{ items.order.cancel_reason }})</label
      >
      <br />
      <div class="order-date">
        <div class="my-auto">วันที่สั่งตรวจ :</div>
        <div class="input-datetime">
          <datetime
            v-model="dateNow"
            :input-class="{
              'form-control': true,
            }"
            type="date"
            class="theme-orange datepicker-trigger input-group"
            placeholder="Select Date"
            format="dd-MM-yyyy"
            :disabled="items.order.status_id == 6"
            value-zone="local"
          />
          <!--          <b-form-input style="width: 10vw;"  :value="items[0].order.order_date"></b-form-input>-->
        </div>
        <div class="">
          <datetime
            v-model="timeNow"
            :input-class="{
              'form-control': true,
            }"
            type="time"
            class="theme-orange datepicker-trigger input-group"
            placeholder="Select Time"
            format="HH:mm:ss"
            value-zone="local"
          />
        </div>
      </div>
    </div>
    <!-- <result-detail-table></result-detail-table> -->
    <div class="form">
      <form novalidate>
        <div class="row text-bold">
          <div class="form-group left col-4">
            <label for="hospitalInput">ชื่อสถานพยาบาล</label>
            <multiselect
              id="hospitalInput"
              v-model="hospitalSelectedObject"
              style="min-width: 200px;"
              deselect-label="✖"
              track-by="id"
              label="name"
              :options="hospitals"
              @input="setHospitalData"
            />
          </div>
          <div class="form-group left col-4">
            <label for="directionInput">เส้นทางวิ่ง</label>
            <input
              v-if="customerData.direction_info.direction"
              id="directionInput"
              v-model="customerData.direction_info.direction.direction"
              type="text"
              class="form-control"
              placeholder="Auto field"
              disabled
            />
            <input
              v-else
              v-model="customerData.direction_info.direction"
              type="text"
              class="form-control"
              placeholder="-"
              disabled
            />
          </div>
          <div class="form-group left col-4">
            <label for="anInput">AN</label>
            <input
              id="anInput"
              v-model="data.an"
              type="text"
              class="form-control"
              required
              disabled
            />
          </div>
        </div>
        <div class="row text-bold">
          <div class="form-group left col-4">
            <label for="formGroupExampleInput">ชื่อสัตว์</label>
            <input
              id="formGroupExampleInput"
              v-model="data.name"
              type="text"
              class="form-control"
              placeholder="Enter name"
            />
          </div>
          <div class="form-group left col-4">
            <label for="formGroupExampleInput">Species</label>
            <multiselect
              id="speciesInput"
              v-model="data.species"
              style="min-width: 200px;"
              select-label
              deselect-label
              selected-label
              label="species_name"
              track-by="id"
              :allow-empty="false"
              :options="species"
              @input="changeValue"
            />
            <template v-if="data.species">
              <div style="margin-top: 1rem">
                <b-form-input
                  v-if="
                    data.species ? data.species.species_name === 'อื่นๆ' : false
                  "
                  v-model="data.other_specie"
                  placeholder="สปีชีส์อื่นๆ"
                />
              </div>
            </template>
          </div>
          <div class="form-group left col-4">
            <label for="formGroupExampleInput">สายพันธุ์</label>
            <multiselect
              id="breed-2-input"
              v-model="data.breed"
              style="min-width: 200px;"
              select-label
              deselect-label
              selected-label
              label="breed_name"
              track-by="id"
              :options="breedsComputed"
              :allow-empty="false"
              @input="changeValue"
            />
            <div style="margin-top: 1rem">
              <b-form-input
                v-if="data.breed ? data.breed.breed_name === 'อื่นๆ' : false"
                v-model="data.other_breed"
                placeholder="สายพันธ์อื่นๆ"
              />
            </div>
          </div>
        </div>
        <div class="row text-bold">
          <div class="form-group left col-4">
            <label for="Gender">เพศ</label>
            <multiselect
              id="genderInput"
              v-model="data.gender.gender_name"
              style="min-width: 200px;"
              select-label
              deselect-label="✖"
              selected-label
              :options="lstGenders"
            />
          </div>
          <div class="form-group left col-4">
            <label for="Age" style="display: flex">อายุ (ปี/เดือน/วัน)</label>
            <div class="row">
              <div class="col age">
                <input
                  id="Age-year"
                  v-model="form_age.year"
                  type="text"
                  class="form-control"
                  placeholder="-"
                />
              </div>
              <div class="col age">
                <!--
                                            <label for="formGroupExampleInput2"></label>
                    -->
                <input
                  id="Age-month"
                  v-model="form_age.month"
                  type="text"
                  class="form-control"
                  placeholder="-"
                />
              </div>
              <div class="col">
                <!--
                                            <label for="formGroupExampleInput2"></label>
                    -->
                <input
                  id="Age-day"
                  v-model="form_age.day"
                  type="text"
                  class="form-control"
                  placeholder="-"
                />
              </div>
            </div>
          </div>
          <div class="form-group left col-4">
            <label for="HN">HN</label>
            <input
              id="HN"
              v-model="data.hn"
              type="text"
              class="form-control"
              placeholder="Enter HN"
            />
          </div>
        </div>
        <div class="row text-bold">
          <div class="form-group left col-2">
            <label for="titleNameInput">คำนำหน้า</label>
            <multiselect
              id="titleNameInput"
              v-model="data.owner_title_name"
              style="min-width: 200px;"
              select-label
              deselect-label
              selected-label
              label="name"
              track-by="id"
              :allow-empty="false"
              :options="ownerTitleNames"
              @input="changeValue"
            />
          </div>
          <div class="form-group left col-5">
            <label for="ownerInput">ชื่อ-สกุลเจ้าของ</label>
            <input
              id="ownerInput"
              v-model="data.owner_name"
              type="text"
              class="form-control"
              placeholder="Enter Owner Name"
            />
          </div>
          <div class="form-group left col-5">
            <label for="noteInput">บ้านเลขที่</label>
            <input
              id="doctorInput"
              v-model="data.owner_address"
              type="text"
              class="form-control"
              placeholder="Enter Address"
            />
          </div>
        </div>
        <div class="row text-bold">
          <div class="form-group left col-6">
            <label for="noteInput">ชื่อแพทย์</label>
            <input
              id="doctorInput"
              v-model="data.doctor_name"
              type="text"
              class="form-control"
            />
          </div>
          <div class="form-group left col-6">
            <label for="noteInput">Note</label>
            <input
              id="noteInput"
              v-model="data.note"
              type="text"
              class="form-control"
            />
          </div>
        </div>
      </form>
    </div>
    <div class="text-right">
      <b-button
        v-if="items.order.status_id != 6"
        variant="success"
        @click="updateOrderDate"
        >บันทึก</b-button
      >
    </div>
    <br />

    <div style="font-weight: bold">Tentative Diagnosis</div>

    <br />
    <div>
      <b-row class="my-2">
        <b-col>
          <b-row class="justify-content-start">
            <b-col cols="auto" class="my-auto">
              <span style="font-weight: bold">Specimen Type: </span>
            </b-col>
            <b-col cols="auto" class="my-auto">
              <span>
                {{
                  items.order.specimens
                    ? items.order.specimens
                        .map((specimen) => specimen.name)
                        .join(", ")
                    : ""
                }}
              </span>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-row class="justify-content-end">
            <b-col cols="auto" class="my-auto">
              <label class="check-box emer-check-box">
                <b-form-radio-group
                  id="is-out-lab-radio"
                  v-model="items.order.is_out_lab"
                  :options="isOutLabOptions"
                  name="radio-options"
                />
              </label>
            </b-col>
            <b-col cols="auto" class="my-auto">
              <b-button variant="warning" @click="labTypeUpdateHandler"
                >บันทึก</b-button
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <div style="text-align:left;padding: 10px;">
      <b-button @click="fixTestIssueHandler()">
        แก้ไขปัญหาผลตรวจ
      </b-button>
    </div>
    <div class="nav">
      <!--      for each results title-->
      <template v-for="(item, index) in items.results">
        <!--        ser results color status-->

        <div
          :key="item.index"
          class="item-nav"
          :class="{ 'active-nav': checkListItems[index] }"
          @click="changeStatus(index)"
        >
          <b-container fluid>
            <b-row>
              <b-col cols="auto" class="m-auto py-2">
                <div
                  :key="index"
                  :class="{
                    color: true,
                    red: item.status_id === 1,
                    yellow: item.status_id === 2,
                    pink: item.status_id === 3,
                    blue: item.status_id === 4,
                    green: item.status_id === 5,
                    gray: item.status_id === 6,
                  }"
                />
              </b-col>
              <b-col class="m-auto py-2" cols="auto">
                {{ item.title }}
              </b-col>
              <b-col
                v-if="checkDuplicateTabs(item) && checkListItems[index]"
                class="m-auto delete-button py-2"
                @click="deleteResultHandler"
              >
                <!-- <b-icon icon="exclamation-circle-fill" variant="danger"></b-icon> -->
                <fa-icon style="white" icon="times" />
                <!-- <b-button variant="danger" 
                >X</b-button
              > -->
              </b-col>
            </b-row>
          </b-container>
        </div>
      </template>
    </div>

    <!--      end for each results title-->
    <template v-for="(item, index) in items.results">
      <!--      check show result of header title result-->
      <div v-show="checkListItems[index]" :key="index" class="box">
        <div class="cover-table">
          <div class="tbl-content">
            <table class="default" style="width:100%;">
              <template v-if="!fixResultTemplate(item.title)">
                <thead>
                  <tr>
                    <th>Recheck</th>
                    <th>Test Name</th>
                    <th>Result</th>
                    <th>Last Result</th>
                    <th>Day Last Result</th>
                    <th>Ref.Ranges</th>
                    <th>Unit</th>
                    <!-- <th>QC Regulation</th> -->
                    <th>เครื่องตรวจ</th>
                    <!-- <th style="border-right: 0">Remark</th> -->
                    <th>ใช้ผลตรวจนอก</th>
                    <th>ไฟล์แนบ</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="item.separate_from_test_type">
                    <template v-if="item.has_sub_tests">
                      <template
                        v-for="(test, testIndex) in item.result.sub_tests"
                      >
                        <template v-if="test.input_type === 'heading'">
                          <template
                            v-for="(subTest, subTestIndex) in test.sub_tests"
                          >
                            <test-row
                              :key="`separate-sub-test-heading-${subTestIndex}`"
                              :test.sync="test.sub_tests[subTestIndex]"
                              :last-result="
                                test.sub_tests[subTestIndex].last_result
                              "
                              :day-last-result="
                                test.sub_tests[subTestIndex].day_last_result
                              "
                              :check-test-alert="checkTestAlert"
                              :index-input="testIndex"
                            />
                            <template v-if="subTest.options">
                              <test-row
                                v-if="
                                  subTest.options.find(
                                    (val) => val.value === subTest.value
                                  )
                                    ? subTest.options.find(
                                        (val) => val.value === subTest.value
                                      ).has_sub_test
                                    : null
                                "
                                :key="`options-test-heading-${subTestIndex}`"
                                sub-component
                                :test.sync="test.sub_tests[subTestIndex]"
                                :last-result="
                                  test.sub_tests[subTestIndex].last_result
                                "
                                :day-last-result="
                                  test.sub_tests[subTestIndex].day_last_result
                                "
                                :check-test-alert="checkTestAlert"
                                :index-input="testIndex"
                              />
                            </template>
                          </template>
                        </template>
                        <template v-else>
                          <test-row
                            :key="`separate-sub-test-${testIndex}`"
                            :test.sync="test"
                            :last-result="test.last_result"
                            :day-last-result="test.day_last_result"
                            :check-test-alert="checkTestAlert"
                            :index-input="testIndex"
                          />
                          <template v-if="test.options">
                            <test-row
                              v-if="
                                test.options.find(
                                  (val) => val.value === test.value
                                )
                                  ? test.options.find(
                                      (val) => val.value === test.value
                                    ).has_sub_test
                                  : null
                              "
                              :key="`separate-options-test-${testIndex}`"
                              sub-component
                              :test.sync="test"
                              :last-result="test.last_result"
                              :day-last-result="test.day_last_result"
                              :check-test-alert="checkTestAlert"
                              :index-input="testIndex"
                            />
                          </template>
                        </template>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="item.result.input_type === 'heading'">
                        <template
                          v-for="(subTest, subTestIndex) in item.result
                            .sub_tests"
                        >
                          <test-row
                            :key="
                              `sub-test-${subTestIndex}-of-heading-${index}`
                            "
                            :test="item.result.sub_tests[subTestIndex]"
                            :file-attach.sync="item.files"
                            :last-result="
                              item.result.sub_tests[subTestIndex].last_result
                            "
                            :day-last-result="
                              item.result.sub_tests[subTestIndex]
                                .day_last_result
                            "
                            :check-test-alert="checkTestAlert"
                            :index-input="testIndex"
                          />
                          <template v-if="subTest.options">
                            <test-row
                              v-if="
                                subTest.options.find(
                                  (val) => val.value === subTest.value
                                )
                                  ? subTest.options.find(
                                      (val) => val.value === subTest.value
                                    ).has_sub_test
                                  : null
                              "
                              :key="`options-test-heading-${subTestIndex}`"
                              sub-component
                              :test.sync="item.result.sub_tests[subTestIndex]"
                              :day-last-result="
                                item.result.sub_tests[subTestIndex]
                                  .day_last_result
                              "
                              :last-result="
                                item.result.sub_tests[subTestIndex].last_result
                              "
                              :check-test-alert="checkTestAlert"
                              :index-input="testIndex"
                            />
                          </template>
                        </template>
                      </template>
                      <template v-else>
                        <test-row
                          :test.sync="item.result"
                          :last-result="item.result.last_result"
                          :day-last-result="item.result.day_last_result"
                          :file-attach.sync="item.files"
                          :use-outlab.sync="item.use_outlab"
                          :check-test-alert="checkTestAlert"
                          :index-input="testIndex"
                        />

                        <template v-if="item.result.options">
                          <test-row
                            v-if="
                              item.result.options.find(
                                (val) => val.value === item.result.value
                              )
                                ? item.result.options.find(
                                    (val) => val.value === item.result.value
                                  ).has_sub_test
                                : null
                            "
                            :key="`options-test-${index}`"
                            sub-component
                            :test.sync="
                              item.result.options[
                                item.result.options.findIndex(
                                  (val) => val.value === item.result.value
                                )
                              ]
                            "
                            :day-last-result="
                              item.result.options[
                                item.result.options.findIndex(
                                  (val) => val.value === item.result.value
                                )
                              ].day_last_result
                            "
                            :last-result="
                              item.result.options[
                                item.result.options.findIndex(
                                  (val) => val.value === item.result.value
                                )
                              ].last_result
                            "
                            :check-test-alert="checkTestAlert"
                            :index-input="testIndex"
                          />
                        </template>
                      </template>
                    </template>
                  </template>
                  <!-- NOTE: separate from test type -->
                  <template v-else>
                    <template v-for="(test, testIndex) in item.tests">
                      <template v-if="test.result.input_type === 'heading'">
                        <template
                          v-for="(subTest, subTestIndex) in test.result
                            .sub_tests"
                        >
                          <test-row
                            :key="`test-heading-${subTestIndex}`"
                            :test.sync="test.result.sub_tests[subTestIndex]"
                            :file-attach.sync="test.files"
                            :last-result="
                              test.result.sub_tests[subTestIndex].last_result
                            "
                            :day-last-result="
                              test.result.sub_tests[subTestIndex]
                                .day_last_result
                            "
                            :check-test-alert="checkTestAlert"
                            :index-input="testIndex"
                          />
                          <template v-if="subTest.options">
                            <test-row
                              v-if="
                                subTest.options.find(
                                  (val) => val.value === subTest.value
                                )
                                  ? subTest.options.find(
                                      (val) => val.value === subTest.value
                                    ).has_sub_test
                                  : null
                              "
                              :key="`test-heading-options-test-${subTestIndex}`"
                              sub-component
                              :test.sync="test.result.sub_tests[subTestIndex]"
                              :last-result="
                                test.result.sub_tests[subTestIndex].last_result
                              "
                              :day-last-result="
                                test.result.sub_tests[subTestIndex]
                                  .day_last_result
                              "
                              :check-test-alert="checkTestAlert"
                              :index-input="testIndex"
                            />
                          </template>
                        </template>
                      </template>
                      <template v-else>
                        <test-row
                          :key="`test-index-${testIndex}`"
                          :test.sync="test.result"
                          :last-result="test.result.last_result"
                          :day-last-result="test.result.day_last_result"
                          :file-attach.sync="test.files"
                          :use-outlab.sync="test.use_outlab"
                          :check-test-alert="checkTestAlert"
                          :index-input="testIndex"
                        />
                        <template v-if="test.result.options">
                          <test-row
                            v-if="
                              test.result.options.find(
                                (val) => val.value === test.result.value
                              )
                                ? test.result.options.find(
                                    (val) => val.value === test.result.value
                                  ).has_sub_test
                                : null
                            "
                            :key="`options-test-${testIndex}`"
                            sub-component
                            :test.sync="test.result"
                            :last-result="test.result.last_result"
                            :day-last-result="test.result.day_last_result"
                            :check-test-alert="checkTestAlert"
                            :index-input="testIndex"
                          />
                        </template>
                      </template>
                    </template>
                  </template>
                </tbody>
              </template>
              <template v-else>
                <tbody>
                  <fix-result :test.sync="item" />
                </tbody>
              </template>
              <tfoot>
                <tr v-if="item.has_sub_tests">
                  <th>
                    <b-form-checkbox
                      v-model="item.use_outlab"
                      :value="true"
                      :unchecked-value="false"
                      style="text-align: left"
                      >ใช้ผลตรวจนอก</b-form-checkbox
                    >
                  </th>
                  <th colspan="10">
                    <file-upload-component
                      :file-upload.sync="item.files"
                      :item-index="item.id"
                    />
                  </th>
                </tr>
                <tr>
                  <th colspan="11">
                    <remark-component
                      :remark-input.sync="item.remark_list"
                      :get-remarks="getRemarks"
                      :remark-init="
                        item.separate_from_test_type
                          ? item.remark_list
                          : item.tests[0].remark_list
                      "
                      :other-remark-init="
                        item.separate_from_test_type
                          ? item.remark
                          : item.tests[0].remark
                      "
                      :other-remark.sync="item.remark"
                      label="remarks"
                      track-by="remarks"
                      place-holder="select remark (optional)"
                    />
                  </th>
                </tr>
                <tr v-if="item.test_type.is_check_approve">
                  <th colspan="11" class="text-left">
                    <b-form-checkbox
                      id="finalResult"
                      v-model="item.is_approve"
                      name="finalResult"
                      :value="true"
                      :indeterminate="false"
                      >Final Result</b-form-checkbox
                    >
                  </th>
                </tr>
                <tr>
                  <th>
                    <label :for="`recorded-${index}`">RECORDED BY :</label>
                  </th>
                  <th colspan="2">
                    <b-form-input
                      :id="`recorded-${index}`"
                      type="text"
                      class="form-control mx-sm-2"
                      disabled
                      :value="item.recorder ? item.recorder : '-'"
                    />
                  </th>
                  <th colspan="8" class="text-left">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="record(index)"
                    >
                      RECORD
                    </button>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </template>
    <br />
    <div class="group-approve">
      <div class="form-group row">
        <label for="reported" class="col-sm-2 col-form-label"
          >REPORTED BY</label
        >
        <div class="col-sm-4">
          <input
            id="reported"
            class="form-control"
            :value="
              +items.order.status_id !== 8 &&
              +items.order.status_id !== 5 &&
              items.order.approving_number <= 0
                ? ''
                : items.latest_report
                ? items.latest_report.user.name
                : ''
            "
            disabled
          />
        </div>
        <label for="reported-date" class="col-sm-2 col-form-label"
          >วันเวลา</label
        >
        <div class="col-sm-4">
          <input
            id="reported-date"
            class="form-control"
            :value="
              +items.order.status_id !== 8 &&
              +items.order.status_id !== 5 &&
              items.order.approving_number <= 0
                ? ''
                : items.latest_report
                ? items.latest_report.created_at
                : ''
            "
            disabled
          />
        </div>
      </div>
      <div class="form-group row">
        <label for="approved" class="col-sm-2 col-form-label"
          >APPROVED BY</label
        >
        <div class="col-sm-4">
          <input
            id="approved"
            class="form-control"
            :value="
              +items.order.status_id !== 5 && items.order.approving_number <= 0
                ? ''
                : items.latest_approve
                ? items.latest_approve.user.name
                : ''
            "
            disabled
          />
        </div>
        <label for="approved-date" class="col-sm-2 col-form-label"
          >วันเวลา</label
        >
        <div class="col-sm-4">
          <input
            id="approved-date"
            class="form-control"
            :value="
              +items.order.status_id !== 5 && items.order.approving_number <= 0
                ? ''
                : items.latest_approve
                ? items.latest_approve.created_at
                : ''
            "
            disabled
          />
        </div>
      </div>
      <div class="group-button pb-5">
        <div class="group-button-row">
          <button
            type="button"
            class="btn btn-primary menu-button"
            @click="previewPDF"
          >
            PREVIEW
          </button>
        </div>
        <div class="group-button-row">
          <button
            type="button"
            class="btn btn-primary menu-button reject-btn"
            @click="showRejectModel"
          >
            REJECT
          </button>
          <button
            type="button"
            class="btn btn-primary menu-button report-btn"
            @click="showConfirmPasswordModal('report')"
          >
            REPORT
          </button>
          <button
            type="button"
            class="btn btn-primary menu-button approve-btn"
            @click="showConfirmPasswordModal('approve')"
          >
            APPROVE
          </button>
        </div>
      </div>
    </div>
    <div class="text-left">
      <table class="table history-table text-left">
        <tr>
          <th>สร้างโดย</th>
          <th>แก้ไขล่าสุดโดย</th>
          <th>รับสิ่งตรวจโดย</th>
          <th>Record ล่าสุดโดย</th>
          <th>รายงานผลล่าสุดโดย</th>
          <th>Approve ล่าสุดโดย</th>
          <th>ยกเลิกโดย</th>
          <th>Reject โดย</th>
        </tr>
        <tr>
          <td>
            {{ items.order.createdBy ? items.order.createdBy.name : "-" }}
          </td>
          <td>
            {{ items.order.updatedBy ? items.order.updatedBy.name : "-" }}
          </td>
          <td>
            {{
              items.order.latestReceivedBy
                ? items.order.latestReceivedBy.user.name
                : "-"
            }}
          </td>
          <td>
            {{
              items.order.latestRecordedBy
                ? items.order.latestRecordedBy.user.name
                : "-"
            }}
          </td>
          <td>
            {{
              items.order.latestReportedBy
                ? items.order.latestReportedBy.user.name
                : "-"
            }}
          </td>
          <td>
            {{
              items.order.latestApproveUser
                ? items.order.latestApproveUser.user.name
                : "-"
            }}
          </td>
          <td>
            {{
              items.order.latestCanceledBy
                ? items.order.latestCanceledBy.user.name
                : "-"
            }}
          </td>
          <td>
            {{
              items.order.latestRejectedBy
                ? items.order.latestRejectedBy.user.name
                : "-"
            }}
          </td>
        </tr>
        <tr>
          <td>{{ items.order.created_at ? items.order.created_at : "-" }}</td>
          <td>{{ items.order.updated_at ? items.order.updated_at : "-" }}</td>
          <td>
            {{
              items.order.latestReceivedBy
                ? items.order.latestReceivedBy.created_at
                : "-"
            }}
          </td>
          <td>
            {{
              items.order.latestRecordedBy
                ? items.order.latestRecordedBy.created_at
                : "-"
            }}
          </td>
          <td>
            {{
              items.order.latestReportedBy
                ? items.order.latestReportedBy.created_at
                : "-"
            }}
          </td>
          <td>
            {{
              items.order.latestApproveUser
                ? items.order.latestApproveUser.created_at
                : "-"
            }}
          </td>
          <td>
            {{
              items.order.latestCanceledBy
                ? items.order.latestCanceledBy.created_at
                : "-"
            }}
          </td>
          <td>
            {{
              items.order.latestRejectedBy
                ? items.order.latestRejectedBy.created_at
                : "-"
            }}
          </td>
        </tr>
      </table>
    </div>
    <b-modal
      id="myModal"
      ref="previewModal"
      centered
      title="PREVIEW"
      ok-variant="success"
      ok-title="บันทึก"
      cancel-title="ยกเลิก"
      size="xl"
      hide-footer
    >
      <div class="modal-body" />
    </b-modal>
    <b-modal
      id="confirmPasswordModal"
      ref="confirmPasswordModal"
      centered
      title="Confirm Password"
      ok-variant="success"
      ok-title="บันทึก"
      cancel-title="ยกเลิก"
    >
      <div class="modal-body">
        <!--        <form>-->
        <div class="form-group">
          <label for="sel1" class="col-form-label left" style="width: 100%"
            >Password :</label
          >
          <input
            id="password"
            v-model="confirmPassword"
            type="password"
            class="form-control"
            placeholder="Enter password"
            @keyup.enter="pushOrderAction"
          />
        </div>
        <!--        </form>-->
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn
          class="float-right ml-2"
          variant="success"
          @click="pushOrderAction"
          >ยืนยัน</b-btn
        >
        <b-btn
          class="float-right"
          variant="secondary"
          @click="hideConfirmPasswordModal"
          >ยกเลิก</b-btn
        >
      </div>
    </b-modal>
    <b-modal
      id="myModal"
      ref="rejectModal"
      centered
      title="reject สิ่งตรวจ"
      ok-variant="success"
      ok-title="บันทึก"
      cancel-title="ยกเลิก"
      @shown="clearReasonSelect"
    >
      <div class="modal-body">
        <form>
          <div class="form-group">
            <label for="sel1" class="col-form-label left" style="width: 100%"
              >เหตุผล:</label
            >
            <select id="sel1" v-model="reasonSelect" class="form-control">
              <option value disabled hidden selected>โปรดเลือก</option>
              <option
                v-for="option in getRejectReason"
                :key="option.reason"
                :value="option"
              >
                {{ option.reason }}
              </option>
              <!--<option value="ลูกค้าขอยกเลิก"-->
              <!--&gt;ลูกค้าขอยกเลิก</option-->
              <!--&gt;-->
              <!--<option value="อื่นๆ">อื่นๆ</option>-->
            </select>
          </div>
          <div
            v-show="reasonSelect != null && reasonSelect.is_detail"
            class="form-group"
          >
            <label
              for="message-text"
              class="col-form-label left"
              style="width: 100%"
              >อื่นๆโปรดระบุ :</label
            >
            <textarea
              id="message-text"
              v-model="reasonDetail"
              class="form-control"
            />
          </div>
        </form>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn
          class="float-right ml-2"
          variant="success"
          @click="showConfirmPasswordModal('reject')"
          >ยืนยัน</b-btn
        >
        <b-btn class="float-right" variant="secondary" @click="hideRejectModal"
          >ยกเลิก</b-btn
        >
      </div>
    </b-modal>
    <template v-if="listBarcode != []">
      <template v-for="barcode in listBarcode">
        <img v-show="false" :id="'barcode' + barcode" :key="barcode.index" />
      </template>
    </template>
    <print-component
      v-for="t in isPreview"
      :key="t"
      :ref="`print-object-component`"
    />
    <notifications group="alert" position="bottom right" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import PrintComponent from "../../components/Print/PrintComponent.vue";
import RemarkComponent from "../../components/Result/RemarkComponent";
import FileUploadComponent from "../../components/Result/FileUploadComponent";
import moment from "moment-timezone";
import printJS from "print-js";
import _ from "lodash";
import Swal from "sweetalert2";
import TestRow from "../../components/Result/TestRow";
import { checkResultAlert } from "../../utils/TestUtil";
import { fixResult } from "../../utils/Constants";
import FixResult from "../../components/Result/FixResult";

export default {
  name: "ResultDetail",
  components: {
    PrintComponent,
    RemarkComponent,
    FileUploadComponent,
    TestRow,
    FixResult,
  },
  props: {
    orderId: {
      type: Number,
    },
  },
  data() {
    return {
      numOfInput: [],
      checkListItems: {},
      form_age: {
        year: null,
        month: null,
        day: null,
      },
      hasDuplicateResult: false,
      selectedBP: "",
      cmMajor: "",
      cmMinor: "",
      orderAction: "",
      confirmPassword: "",
      reasonSelect: null,
      reasonDetail: "",
      listBarcode: [],
      remarkInput: {},
      isPreview: [],
      isLoading: false,
      dateNow: "",
      timeNow: "",
      lstHospitals: [],
      objHospitals: [],
      hospitalSelectedObject: null,
      fileInput: [],
      useOutLab: [],
      selectedTest: null,
      lstGenders: [],
      objGenders: [],
      isOutLab: null,
      isOutLabOptions: [
        { text: "In Lab", value: false },
        { text: "Out Lab", value: true },
      ],
      ownerTitleNames: [],
    };
  },
  async created() {},
  async mounted() {
    this.$nextTick(() => {
      this.setHospitals();
    });
    this.form_age.year = this.setYear(this.data.age);
    this.form_age.month = this.setMonth(this.data.age);
    this.form_age.day = this.setDay(this.data.age);
    this.setCheckListItem(this.items.results);
    // this.setSelectedBP();
    // this.setCM();
    await this.setRemarks();
    await this.setGenders();

    // if (this.items.order.is_out_lab === null) {
    //   this.items.order.is_out_lab = false;
    // }

    const getOwnerTitleNames = await this.getOwnerTitleNames();

    this.ownerTitleNames = [
      { id: null, name: "ไม่ระบุ" },
      ...getOwnerTitleNames.title,
    ];

    if (!this.data.owner_title_name) {
      this.data.owner_title_name = this.ownerTitleNames[0];
    }

    this.dateNow = this.items.order.order_date;
    this.timeNow = moment(this.items.order.order_date_time).format();

    if (this.items.results.length > 0) {
      const item = this.items.results;
      if (item.title === "Complete Blood Count (CBC)") {
        this.CBCMachineChecker(item);
      }
    }

    checkResultAlert(this.selectedTest, null, "mounted");

    const itemDuplicate = this.items.results.filter((result) => {
      if (result.separate_from_test_type) {
        return (
          result.barcode === this.selectedTest.barcode &&
          result.test_id === this.selectedTest.test_id
        );
      } else {
        return (
          result.test_type.id === this.selectedTest.test_type.id &&
          result.separate_from_test_type === result.separate_from_test_type
        );
      }
    });

    if (itemDuplicate.length > 1) {
      this.hasDuplicateResult = true;
    } else {
      this.hasDuplicateResult = false;
    }
  },
  // components: { ResultDetailTable },
  computed: {
    ...mapGetters({
      items: "Result/getResult",
      data: "Animal/getData",
      customerData: "Hospital/getData",
      readOnly: "Order/getReadOnly",
      user: "Auth/getUser",
      getRejectReason: "RejectReason/getAll",
      getRemarks: "Result/getRemarks",
      hospitals: "Hospital/getAll",
      genders: "Gender/getAll",
      species: "Species/getAll",
      breeds: "Breed/getAll",
    }),
    breedsComputed() {
      let specie = this.data.species;
      if (!specie) {
        return this.breeds;
      }
      return this.breeds.filter(
        (breed) => breed.species_id === specie.id || breed.species_id === null
      );
    },
  },
  methods: {
    ...mapActions({
      getOwnerTitleNames: "Animal/getOwnerTitleName",
      updateOrder: "Order/updateOrder",
      editResult: "Result/editResult",
      deleteResult: "Result/deleteResult",
      setResult: "Result/setResult",
      approveOrder: "Order/approveOrder",
      reportOrder: "Order/reportOrder",
      rejectOrder: "Order/rejectOrder",
      setAnimalData: "Animal/setData",
      setRemarks: "Result/setRemarks",
      checkPermission: "Order/checkPermission",
      setCustomerData: "Hospital/setData",
      updateLabType: "Order/updateLabType",
      fixTestIssue: "Result/fixTestIssue",
    }),
    async fixTestIssueHandler() {
      this.$store.state.isLoading = true;
      try {
        await this.fixTestIssue(this.items.order.ln);
      } catch (error) {
        alert(error.message);
        this.$store.state.isLoading = false;
      }

      await this.setResult(this.items.order.id);

      checkResultAlert(this.selectedTest, null, "mounted");

      // console.log(this.checkListItems)
      const testSelectedIndex = Object.entries(this.checkListItems).findIndex(
        (list) => list
      );

      this.selectedTest = this.items.results[testSelectedIndex];

      const itemDuplicate = this.items.results.filter((result) => {
        if (result.separate_from_test_type) {
          return (
            result.barcode === this.selectedTest.barcode &&
            result.test_id === this.selectedTest.test_id
          );
        } else {
          return (
            result.test_type.id === this.selectedTest.test_type.id &&
            result.separate_from_test_type === result.separate_from_test_type
          );
        }
      });

      if (itemDuplicate.length > 1) {
        this.hasDuplicateResult = true;
      } else {
        this.hasDuplicateResult = false;
      }

      this.$store.state.isLoading = false;
    },
    checkDuplicateTabs(item) {
      if (this.items) {
        const itemDuplicate = this.items.results.filter((result) => {
          if (result.separate_from_test_type) {
            return (
              result.barcode === item.barcode &&
              result.test_id === item.test_id &&
              item.separate_from_test_type === result.separate_from_test_type
            );
          } else {
            return (
              result.test_type.id === item.test_type.id &&
              result.separate_from_test_type ===
                result.separate_from_test_type &&
              item.separate_from_test_type === result.separate_from_test_type
            );
          }
        });

        if (itemDuplicate.length > 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    async deleteResultHandler() {
      // this.checkListItems[index] = true;
      let index;
      for (var key in this.checkListItems) {
        if (this.checkListItems[key]) {
          index = key;
        }
      }
      // console.log(this.checkListItems);
      const item = this.items.results[index];

      const { value: password } = await this.$swal.fire({
        title: "กรอกรหัสผ่านเพื่อดำเนินการต่อไป",
        input: "password",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
      });
      if (password) {
        this.$store.state.isLoading = true;
        try {
          await this.deleteResult({ id: item.id, password });
        } catch (err) {
          this.$swal.fire("เกิดข้อผิดพลาด", err.message, "error");
          this.$store.state.isLoading = false;
          return;
        }

        await this.setResult(this.items.order.id);

        checkResultAlert(this.selectedTest, null, "mounted");

        await this.$swal.fire(
          "ลบเสร็จสิ้น",
          "ลบผลตรวจที่เลือกเสร็จสิ้น",
          "success"
        );
        this.$store.state.isLoading = false;
      } else {
        return;
      }
    },
    async labTypeUpdateHandler() {
      if (this.$store.state.isLoading) {
        return;
      }

      this.$store.state.isLoading = true;

      await this.updateLabType({
        id: this.items.order.id,
        payload: { is_out_lab: this.items.order.is_out_lab },
      });

      await this.setResult(this.items.order.id);

      checkResultAlert(this.selectedTest, null, "mounted");

      // console.log(this.checkListItems)
      const testSelectedIndex = Object.entries(this.checkListItems).findIndex(
        (list) => list
      );

      this.selectedTest = this.items.results[testSelectedIndex];

      const itemDuplicate = this.items.results.filter((result) => {
        if (result.separate_from_test_type) {
          return (
            result.barcode === this.selectedTest.barcode &&
            result.test_id === this.selectedTest.test_id
          );
        } else {
          return (
            result.test_type.id === this.selectedTest.test_type.id &&
            result.separate_from_test_type === result.separate_from_test_type
          );
        }
      });

      if (itemDuplicate.length > 1) {
        this.hasDuplicateResult = true;
      } else {
        this.hasDuplicateResult = false;
      }

      this.$store.state.isEditing = false;
      this.$store.state.isLoading = false;
      this.$swal.fire("Success", "บันทึกข้อมูลแล้ว", "success");
    },
    setGenders() {
      const array = [];
      const obj = [];
      // console.log(this.genders);
      this.genders.forEach((element) => {
        array.push(element.gender_name);
        obj[element.gender_name] = element.id;
      });
      this.lstGenders = array;
      this.objGenders = obj;
    },
    changeValue(val) {
      this.$store.state.isEditing = true;
    },
    async setHospitalData(value) {
      this.data.hospital_name = value.name;
      this.data.hospital_id = value.id;
      // const id = this.objHospitals[this.data.hospital_name]
      //   ? this.objHospitals[this.data.hospital_name]
      //   : "";
      this.$store.state.isLoading = true;
      this.setCustomerData(value.id);
      this.$store.state.isLoading = false;
    },
    async setHospitals() {
      const array = [];
      const obj = [];
      await this.hospitals.forEach((element) => {
        array.push(element.name);
        obj[element.name] = element.id;
      });
      this.lstHospitals = array;
      this.objHospitals = obj;
      this.hospitalSelectedObject = this.hospitals.find(
        (hospital) => hospital.id == this.data.hospital_id
      );
    },
    async permission(type, mod) {
      let permission = await this.checkPermission({
        type: type,
        mod: mod,
      });

      if (!permission) {
        // this.$notify({
        //   group: "alert",
        //   title: "มีข้อผิดพลาดบางอย่าง",
        //   text: permission,
        //   position: "bottom right",
        //   type: "error"
        // });
        await this.$swal.fire("มีข้อผิดพลาดบางอย่าง", permission, "error");
        return false;
      }
      return true;
    },
    async updateOrderDate() {
      if (this.$store.state.isLoading) {
        return;
      }
      this.$store.state.isLoading = true;
      let permission = await this.permission("result", "can_edit");

      if (permission) {
        const payload = {
          id: this.items.order.id,
          order_date: moment(this.dateNow).format("YYYY-MM-DD"),
          order_date_time:
            moment(this.dateNow).format("YYYY-MM-DD") +
            " " +
            moment(this.timeNow).format("HH:mm:ss"),
          note: this.data.note,
          doctor_name: this.data.doctor_name,
          hospital_id: this.data.hospital_id,
          name: this.data.name,
          owner_name: this.data.owner_name,
          owner_surname: this.data.owner_surname,
          owner_address: this.data.owner_address,
          owner_title_name: this.data.owner_title_name,
          hn: this.data.hn,
          age:
            this.form_age.year +
            "-" +
            this.form_age.month +
            "-" +
            this.form_age.day,
          sex: this.objGenders[this.data.gender.gender_name]
            ? this.objGenders[this.data.gender.gender_name]
            : 3,
          breed_id: this.data.breed ? this.data.breed.id : 1,
          species_id: this.data.species ? this.data.species.id : 1,
          other_specie: this.data.other_specie,
          other_breed: this.data.other_breed,
        };
        // console.log(payload)
        await this.updateOrder(payload);

        await this.setResult(this.items.order.id);

        checkResultAlert(this.selectedTest, null, "mounted");

        // console.log(this.checkListItems)
        const itemDuplicate = this.items.results.filter((result) => {
          if (result.separate_from_test_type) {
            return (
              result.barcode === this.selectedTest.barcode &&
              result.test_id === this.selectedTest.test_id
            );
          } else {
            return (
              result.test_type.id === this.selectedTest.test_type.id &&
              result.separate_from_test_type === result.separate_from_test_type
            );
          }
        });

        if (itemDuplicate.length > 1) {
          this.hasDuplicateResult = true;
        } else {
          this.hasDuplicateResult = false;
        }

        this.$store.state.isEditing = false;
        this.$swal.fire("Success", "บันทึกข้อมูลแล้ว", "success");
      }
      this.$store.state.isLoading = false;
    },
    setSelectedBP() {
      let check = this.items.results.find((x) => x.special_test_id === 36);
      if (check != undefined) {
        const obj = this.items.find((x) => x.special_test_id === 36).result[0]
          .options[0].check;
        if (obj) {
          this.selectedBP = "Not found";
        } else {
          this.selectedBP = "Found";
        }
      }
    },
    setCM() {
      let check = this.items.find((x) => x.special_test_id === 42);
      if (check != undefined) {
        const objMajor = this.items.find((x) => x.special_test_id === 42)
          .result[0].major[0].check;
        if (objMajor) {
          this.cmMajor = this.items.find(
            (x) => x.special_test_id === 42
          ).result[0].major[0].title;
        } else {
          this.cmMajor = this.items.find(
            (x) => x.special_test_id === 42
          ).result[0].major[1].title;
        }
        const objMinor = this.items.find((x) => x.special_test_id === 42)
          .result[0].minor[0].check;
        if (objMinor) {
          this.cmMinor = this.items.find(
            (x) => x.special_test_id === 42
          ).result[0].minor[0].title;
        } else {
          this.cmMinor = this.items.find(
            (x) => x.special_test_id === 42
          ).result[0].minor[1].title;
        }
      }
    },
    goResultPage() {
      this.$router.push({ name: "result" });
      // console.log(this.data);
    },
    setYear(date) {
      if (!date) {
        return "";
      }
      var array = date.split("-");
      if (array[0] === undefined) {
        return "";
      }
      return array[0];
    },
    setMonth(date) {
      if (!date) {
        return "";
      }
      var array = date.split("-");
      if (array[1] === undefined) {
        return "";
      }
      return array[1];
    },
    setDay(date) {
      if (!date) {
        return "";
      }
      var array = date.split("-");
      if (array[2] === undefined) {
        return "";
      }
      return array[2];
    },
    changeStatus(index) {
      // this.checkListItems[index] = true;
      for (var key in this.checkListItems) {
        this.checkListItems[key] = false;
      }
      this.checkListItems[index] = true;
      // console.log(this.checkListItems);
      const item = this.items.results[index];
      this.selectedTest = item;

      const itemDuplicate = this.items.results.filter((result) => {
        if (result.separate_from_test_type) {
          return (
            result.barcode === item.barcode && result.test_id === item.test_id
          );
        } else {
          return (
            result.test_type.id === item.test_type.id &&
            result.separate_from_test_type === result.separate_from_test_type
          );
        }
      });

      if (itemDuplicate.length > 1) {
        this.hasDuplicateResult = true;
      } else {
        this.hasDuplicateResult = false;
      }
    },
    setCheckListItem(array) {
      var obj = {};
      for (let index = 0; index < array.length; index++) {
        if (index == 0) {
          obj[index] = true;
          this.selectedTest = array[index];
        } else {
          obj[index] = false;
        }
      }
      this.checkListItems = obj;
    },
    async setTestKitForm(result, index) {
      const arrayId = [];
      await result.forEach((element) => {
        arrayId.push(element.id);
      });
      this.record(arrayId, index);
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async record(index) {
      if (this.isRecording) {
        return;
      }
      this.isRecording = true;
      this.$store.state.isLoading = true;
      let permission = await this.permission("result", "can_record");

      if (permission) {
        try {
          await this.checkTestAlert();
        } catch (err) {
          this.$store.state.isLoading = false;
          this.isRecording = false;
          return;
        }

        const selectedRecorded = this.items.results[index];

        await this.sleep(Math.floor(Math.random() * (1000 - 0 + 1)) + 0);

        if (selectedRecorded.result) {
          if (selectedRecorded.result.input_type === "dropdown") {
            const optionSelected = selectedRecorded.result.options.find(
              (option) => option.name === selectedRecorded.result.value
            );

            if (!optionSelected) {
              await this.$swal.fire(
                "บันทึกข้อมูลไม่สำเร็จ",
                "กรุณาใส่ค่าข้อมูลให้ครบ",
                "error"
              );
              this.$store.state.isLoading = false;
              this.isRecording = false;
              return;
            }

            if (optionSelected.has_sub_test) {
              if (!optionSelected.option_value) {
                await this.$swal.fire(
                  "บันทึกข้อมูลไม่สำเร็จ",
                  "กรุณาใส่ค่าข้อมูลให้ครบ",
                  "error"
                );
                this.$store.state.isLoading = false;
                this.isRecording = false;
                return;
              }

              if (typeof optionSelected.option_value === "object") {
                if (optionSelected.option_value.length <= 0) {
                  await this.$swal.fire(
                    "บันทึกข้อมูลไม่สำเร็จ",
                    "กรุณาใส่ค่าข้อมูลให้ครบ",
                    "error"
                  );
                  this.$store.state.isLoading = false;
                  this.isRecording = false;
                  return;
                }
              }
            }
          }
        }

        let response = await this.editResult(selectedRecorded);
        // let res = false
        if (response) {
          // this.$notify({
          //   group: "alert",
          //   title: "บันทึกข้อมูลสำเร็จ",
          //   text: "บันทึกข้อมูลผลตรวจสำเร็จ",
          //   position: "bottom right",
          //   type: "success"
          // });
          await this.$swal.fire(
            "บันทึกข้อมูลสำเร็จ",
            "บันทึกข้อมูลผลตรวจสำเร็จ",
            "success"
          );
        } else {
          // this.$notify({
          //   group: "alert",
          //   title: "มีข้อผิดพลาดบางอย่าง",
          //   text: "ไม่สามารถบันทึกผลตรวจได้ กรุณาติดต่อเจ้าหน้าที่",
          //   position: "bottom right",
          //   type: "error"
          // });
          await this.$swal.fire(
            "มีข้อผิดพลาดบางอย่าง",
            "ไม่สามารถบันทึกผลตรวจได้ กรุณาติดต่อเจ้าหน้าที่",
            "error"
          );
        }
        await this.setResult(this.items.order.id);

        checkResultAlert(this.selectedTest, null, "mounted");

        // console.log(this.checkListItems)
        const testSelectedIndex = Object.entries(this.checkListItems).findIndex(
          (list) => list
        );

        this.selectedTest = this.items.results[testSelectedIndex];

        const itemDuplicate = this.items.results.filter((result) => {
          if (result.separate_from_test_type) {
            return (
              result.barcode === this.selectedTest.barcode &&
              result.test_id === this.selectedTest.test_id
            );
          } else {
            return (
              result.test_type.id === this.selectedTest.test_type.id &&
              result.separate_from_test_type === result.separate_from_test_type
            );
          }
        });

        if (itemDuplicate.length > 1) {
          this.hasDuplicateResult = true;
        } else {
          this.hasDuplicateResult = false;
        }

        this.$store.state.isLoading = false;
        this.isRecording = false;
        return;
      }
      this.$store.state.isLoading = false;
      this.isRecording = false;
    },
    getBlobFile(blob) {
      return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.responseType = "blob";

        xhr.onload = function() {
          let recoveredBlob = xhr.response;

          let reader = new FileReader();

          reader.onload = function() {
            resolve(reader.result);
          };

          reader.readAsDataURL(recoveredBlob);
        };

        xhr.open("GET", blob);
        xhr.send();
      });
    },
    hidePreviewModal() {
      this.$refs.previewModal.hide();
    },
    showPreviewModal() {
      this.$refs.previewModal.show();
    },
    hideConfirmPasswordModal() {
      this.$refs.confirmPasswordModal.hide();
    },
    async showConfirmPasswordModal(action) {
      if (this.$store.state.isLoading) {
        return;
      }

      this.$store.state.isLoading = true;
      let permission = await this.permission("result", `can_${action}`);

      if (permission) {
        this.orderAction = action;
        if (action === "reject") this.hideRejectModal();
        this.$store.state.isLoading = false;
        this.$refs.confirmPasswordModal.show();
      }
      this.$store.state.isLoading = false;
    },
    showRejectModel() {
      this.$refs.rejectModal.show();
    },
    hideRejectModal() {
      this.$refs.rejectModal.hide();
    },
    clearReasonSelect() {
      this.reasonSelect = null;
    },
    async pushOrderAction() {
      if (this.$store.state.isLoading) {
        return;
      }
      let action = this.orderAction;
      this.orderAction = "";
      this.$store.state.isLoading = true;
      this.hideConfirmPasswordModal();
      switch (action) {
        case "approve":
          let res = await this.$store.dispatch("Order/approveOrder", {
            ln: this.items.order.ln,
            payload: {
              password: this.confirmPassword,
            },
          });

          this.$store.state.isLoading = false;
          if (res) {
            if (res.code !== 200) {
              // this.$notify({
              //   group: "alert",
              //   title: "error",
              //   text: res.data.message,
              //   position: "bottom right",
              //   type: "error"
              // });
              await this.$swal.fire(
                "มีข้อผิดพลาดบางอย่าง",
                res.data.message,
                "error"
              );
            } else {
              // this.setResult(this.items.order.id);

              this.$router.push({
                name: "result",
                query: { ln: this.items.order.ln },
              });
              // this.$router.push({ name: "result" });
            }
          } else {
            // this.$notify({
            //   group: "alert",
            //   title: "เกิดข้อผิดพลาด",
            //   text: "รหัสผิดพลาด",
            //   type: "error"
            // });
            await this.$swal.fire(
              "มีข้อผิดพลาดบางอย่าง",
              "รหัสผิดพลาด",
              "error"
            );
          }

          this.confirmPassword = "";

          // this.hideConfirmPasswordModal();

          this.$store.state.isLoading = false;
          break;
        case "reject":
          let reject_res = await this.$store.dispatch("Order/rejectOrder", {
            ln: this.items.order.ln,
            payloadConfirmPassword: {
              password: this.confirmPassword,
            },
            payloadRejectOrder: {
              reason_id: this.reasonSelect.id,
              reason_detail: this.reasonDetail,
            },
          });
          this.confirmPassword = "";
          this.reasonSelect = null;
          this.reasonDetail = "";

          // this.hideConfirmPasswordModal();
          this.$store.state.isLoading = false;
          if (reject_res) {
            if (reject_res.code === 200) {
              // this.$notify({
              //   group: "alert",
              //   title: "บันทึกข้อมูลสำเร็จ",
              //   text: "บันทึกข้อมูลผลตรวจสำเร็จ",
              //   position: "bottom right",
              //   type: "success"
              // });
              await this.$swal.fire(
                "บันทึกข้อมูลสำเร็จ",
                "บันทึกข้อมูลผลตรวจสำเร็จ",
                "success"
              );
            } else {
              // this.$notify({
              //   group: "alert",
              //   title: "เกิดข้อผิดพลาด",
              //   text: reject_res.data.message,
              //   type: "error"
              // });
              await this.$swal.fire(
                "เกิดข้อผิดพลาด",
                reject_res.data.message,
                "error"
              );
            }
          } else {
            // this.$notify({
            //   group: "alert",
            //   title: "เกิดข้อผิดพลาด",
            //   text: "รหัสผิดพลาด",
            //   type: "error"
            // });
            await this.$swal.fire("เกิดข้อผิดพลาด", "รหัสผิดพลาด", "error");
          }

          break;
        case "report":
          let report_reject = await this.$store.dispatch("Order/reportOrder", {
            ln: this.items.order.ln,
            payload: {
              password: this.confirmPassword,
            },
          });
          this.confirmPassword = "";
          this.setResult(this.items.order.id);

          // this.hideConfirmPasswordModal();
          this.$store.state.isLoading = false;

          if (report_reject) {
            if (report_reject.code === 200) {
              // this.$notify({
              //   group: "alert",
              //   title: "บันทึกข้อมูลสำเร็จ",
              //   text: "บันทึกข้อมูลผลตรวจสำเร็จ",
              //   position: "bottom right",
              //   type: "success"
              // });
              await this.$swal.fire(
                "บันทึกข้อมูลสำเร็จ",
                "บันทึกข้อมูลผลตรวจสำเร็จ",
                "success"
              );
            } else {
              // this.$notify({
              //   group: "alert",
              //   title: "เกิดข้อผิดพลาด",
              //   text: report_reject.data.message,
              //   type: "error"
              // });
              await this.$swal.fire(
                "เกิดข้อผิดพลาด",
                report_reject.data.message,
                "error"
              );
            }
          } else {
            // this.$notify({
            //   group: "alert",
            //   title: "เกิดข้อผิดพลาด",
            //   text: "รหัสผิดพลาด",
            //   type: "error"
            // });
            await this.$swal.fire("เกิดข้อผิดพลาด", "รหัสผิดพลาด", "error");
          }

          break;
      }
    },
    async previewPDF() {
      if (this.$store.state.isLoading) {
        return;
      }
      this.$store.state.isLoading = true;
      let permission = await this.permission("result", "can_print");
      if (permission) {
        // if (this.fileInput.filter(file => file.length > 0).length === 0 && this.items.filter(item => !item.has_outlab).length === 0) {
        //   this.$notify({
        //     group: "alert",
        //     title: "เกิดข้อผิดพลาด",
        //     text: 'ไม่มีข้อมูลปริ้นท์',
        //     type: "error"
        //   });
        // }
        // this.isPreview.push(true);
        // let d = new printd();
        await this.$nextTick().then(async () => {
          await this.$nextTick().then(async () => {
            // d.print(this.$refs[`print-object-component`][0].$el)
            this.$store.state.isLoading = false;
            printJS({
              printable: `${process.env.VUE_APP_IP}/print/${this.items.order.id}`,
              type: "pdf",
              showModal: true,
            });
            // this.isPreview = [];
          });
        });
      }
      this.$store.state.isLoading = false;
    },
    checkRanges(id, refRanges, inputObject = null, inputName = null) {
      if (inputObject) {
        if (inputObject.type === "CBC") {
          this.CBCChecker(inputObject, inputName);
        }
      }
      let el = document.getElementById(id);
      if (!el) {
        return (el.style.background = "#a5ffa7");
      }

      let value = el.value;

      if (!refRanges) {
        return (el.style.background = "#a5ffa7");
      }
      let ranges = refRanges.split("-");
      if (value === "") {
        el.style.background = "";
      } else if (!this.$v.isNumeric(value)) {
        el.style.background = "#ff7070";
        // } else if (this.$_.inRange(parseFloat(value), parseFloat(ranges[0]), parseFloat(ranges[1]))) {
      } else if (
        parseFloat(value) >= parseFloat(ranges[0]) &&
        parseFloat(value) <= parseFloat(ranges[1])
      ) {
        el.style.background = "#a5ffa7";
      } else {
        el.style.background = "#ff7070";
      }
    },
    CBCChecker(cbc, inputName) {
      const plusCase = [
        "Neutrophils",
        "Band",
        "Lymphocytes",
        "Monocytes",
        "Eosinophils",
        "Basophils",
        "Heterophils",
        "Atypical lymphocytes",
        "Lymphoblast",
        "Monoblast",
      ];
      if (!plusCase.includes(inputName)) {
        return;
      }

      const results = cbc.results;
      // const RBC = results.find(result => result.sub_title === 'RBC').result
      // const hemoglobin = results.find(result => result.sub_title === 'Hemoglobin').result
      // const hematocrit = results.find(result => result.sub_title === 'Hematocrit').result
      // const MCV = result.find(result => result.sub_title === 'Indices MCV').result
      // const MCH = result.find(result => result.sub_title === 'MCH').result
      // const MCHC = result.find(result => result.sub_title === 'MCHC').result

      const resultPlusCase = results.filter((result) =>
        plusCase.includes(result.sub_title)
      );
      const plusCaseSum = _.sum(resultPlusCase.map((result) => +result.result));

      if (plusCaseSum > 100) {
        Swal.fire(
          "คำเตือน",
          `ผลรวมของ ${_.join(plusCase, ", ")}  มากกว่า 100`,
          "warning"
        );
      }

      // if (hematocrit > (hemoglobin * 3)) {
      //   alert('hct > hb * 3')
      // }

      // if (MCV > ((hematocrit / RBC) * 10)){
      //   alert('MCV > ((hematocrit / RBC) * 10)')
      // }

      // if (MCH > ((hemoglobin / RBC) * 10)){
      //   alert('MCH > ((hemoglobin / RBC) * 10)')
      // }

      // if (MCHC > ((hemoglobin / hematocrit) * 100)){
      //   alert('MCHC > ((hemoglobin / hematocrit) * 100)')
      // }
    },
    async CBCMachineChecker(item) {
      const RBC = item.result[0].results.find(
        (result) => result.sub_title === "RBC"
      ).result;
      const hemoglobin = item.result[0].results.find(
        (result) => result.sub_title === "Hemoglobin"
      ).result;
      const hematocrit = item.result[0].results.find(
        (result) => result.sub_title === "Hematocrit"
      ).result;
      const MCV = item.result[0].results.find(
        (result) => result.sub_title === "Indices MCV"
      ).result;
      const MCH = item.result[0].results.find(
        (result) => result.sub_title === "MCH"
      ).result;
      const MCHC = item.result[0].results.find(
        (result) => result.sub_title === "MCHC"
      ).result;

      const hematocritCase = hemoglobin * 3;
      if (hematocrit > hematocritCase) {
        await Swal.fire(
          "คำเตือน",
          `Hematocrit มากกว่า ${hematocritCase.toFixed(2)}`,
          "warning"
        );
      }

      const mcvCase = (hematocrit / RBC) * 10;
      if (MCV > mcvCase) {
        await Swal.fire(
          "คำเตือน",
          `MCV มากกว่า ${mcvCase.toFixed(2)}`,
          "warning"
        );
      }

      const mchCase = (hemoglobin / RBC) * 10;
      if (MCH > mchCase) {
        await Swal.fire(
          "คำเตือน",
          `MCH มากกว่า ${mchCase.toFixed(2)}`,
          "warning"
        );
      }

      const mchcCase = (hemoglobin / hematocrit) * 100;
      if (MCHC > mchcCase) {
        await Swal.fire(
          "คำเตือน",
          `MCHC มากกว่า ${mchcCase.toFixed(2)}`,
          "warning"
        );
      }
    },
    inRanges(value, refRanges) {
      // let el = document.getElementById(id)

      // if (!el)
      //   return true

      if (value === "") {
        return false;
      }

      // let value = value
      if (!refRanges) {
        return true;
      }

      let ranges = refRanges.split("-");

      if (!this.$v.isNumeric(value)) {
        return false;
      } else
        return (
          parseFloat(value) >= parseFloat(ranges[0]) &&
          parseFloat(value) <= parseFloat(ranges[1])
        );
    },
    notInRanges(value, refRanges) {
      if (value === "") {
        return false;
      }
      // let el = document.getElementById(id)

      // if (!el)
      //   return true

      // let value = value
      if (!refRanges) {
        return false;
      }

      let ranges = refRanges.split("-");

      if (!this.$v.isNumeric(value)) {
        return true;
      } else
        return !(
          parseFloat(value) >= parseFloat(ranges[0]) &&
          parseFloat(value) <= parseFloat(ranges[1])
        );
    },
    setOutlab() {
      // console.log(this.useOutLab)
      this.items.forEach((item, index) => {
        this.useOutLab[index] = item.has_outlab;
      });
    },
    async checkTestAlert(test = null, type = "function") {
      const check = checkResultAlert(
        this.items.results.find((result) => result.id === this.selectedTest.id),
        test,
        type
      );

      let isWarning = false;
      for (const checkResult of check) {
        if (checkResult.changeValue !== undefined) {
          eval(
            `this.items.results[${Object.assign(
              [],
              this.checkListItems
            ).findIndex((itemIndex) => itemIndex)}].${checkResult.valueIndex}`
          );
        } else {
          if (!checkResult.canSave) {
            isWarning = true;
          }
        }
        await Swal.fire("คำเตือน", `${checkResult.message}`, "warning");
      }

      if (isWarning) {
        throw new Error("has warning");
      }
    },
    fixResultTemplate(title) {
      return fixResult.includes(title);
    },
    setNumOfInput(index) {
      if (!this.numOfInput[index]) {
        this.numOfInput[index] = 0;
      }
      this.numOfInput[index] += 1;

      return this.numOfInput[index];
    },
  },
};
</script>
<style lang="scss" scoped>
.delete-button {
  color: white;
  background: rgb(255, 0, 0);
  // border-radius: 25px;
  // display: inline-block;
  // padding: 5px;

  &:hover {
    background: rgb(148, 0, 0);
  }
}

#result-detail {
  width: 92vw;
  margin: 0 auto;
  margin-top: 20px;
}
#topic {
  text-align: left;
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 20px;
  color: #2f3438;
}
#sub-topic {
  font-weight: bold;
  margin: 20px;
  margin-left: 60px;
}
.left {
  text-align: left;
}
.form {
  width: 80vw;
  margin: 0 auto;
}
.age {
  padding-right: 0px;
}
.text-red {
  color: red;
}
.text-orange {
  color: orange;
}
.icon {
  cursor: pointer;
}
.right {
  text-align: right;
}
.nav {
  background-color: #848e97;
  align-items: center;
  /*height: 4vh;*/
  // margin: 0.5rem;
  /* border-left: 1px solid;
    border-right: 1px solid; */
}
.item-nav {
  // margin-left: 5px;
  cursor: pointer;
  // padding: 0.5rem;
  // color: white;
}
.active-nav {
  // color: orange;
  background-color: #ddd;
}
.box {
  width: 100%;
  /*height: 546px;*/
  overflow-y: auto;
  background-color: #f4f4f4;
}

.text-bold {
  font-weight: bold;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  /* width: 100%; */
  border: 1px solid #ddd;
  border-left: 0px;
  border-right: 0px;
  /* table-layout: fixed; */
}
th,
td {
  text-align: left;
  padding: 8px;
  border: 1px solid white;
  border-top: 0px;
}
tr:nth-child(even) {
  background-color: #f2f2f2;
}
th {
  /* padding-top: 12px;
  padding-bottom: 12px; */
  text-align: center;
  background-color: rgb(219, 219, 219);
  color: #6b757f;
}
.TK tr > td:nth-child(1),
td:nth-child(3),
td:nth-child(4),
td:nth-child(5) {
  text-align: center;
}
.CBC tr > td:nth-child(1),
td:nth-child(3),
td:nth-child(4),
td:nth-child(5) {
  text-align: center;
}
.default tr > td:nth-child(1),
td:nth-child(3),
td:nth-child(4),
td:nth-child(5) {
  text-align: center;
}
.tbl-header {
  background-color: rgb(219, 219, 219);
  padding-right: 17.5px;
}
.tbl-content {
  /*max-height: 300px;*/
  overflow-x: auto;
  overflow-x: hidden;
  margin-top: 0px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.remark {
  margin-top: 2rem;
  margin-left: 25px;
  padding-bottom: 30px;
}

.recorded {
  font-size: 15px;
  font-weight: bold;
  margin-left: 25px;
  padding-bottom: 30px;
}
.cover-table {
  overflow-x: auto;
  /* height: 342px; */
  background-color: #fff;
}
.sub-box {
  padding: 23px;
  width: 50%;
}
.check-box input[type="checkbox"] {
  position: relative;
  opacity: 0;
  cursor: pointer;
  margin: 0 auto;
}
.checkmark {
  top: 6px;
  height: 18px;
  width: 18px;
  margin: 0 auto;
}
.table-bp {
  margin-top: 23px;
  /* margin-bottom: 23px; */
}
.color {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  align-self: center;
  /* margin: 0 auto; */
  margin-left: 18px;
  justify-content: center;
}
.red {
  background-color: red;
}
.yellow {
  background-color: #ffe927;
}
.pink {
  background-color: pink;
}
.blue {
  background-color: #00d0ec;
}
.green {
  background-color: #48e100;
}
.gray {
  background-color: gray;
}
p {
  word-wrap: break-word;
}
.group-approve {
  width: 50%;
  margin: 0 auto;
}
.group-approve > .group-button {
  width: 50%;
  margin: 0 auto;
}
.group-button-row {
  display: flex;
}
.menu-button {
  flex: 1;
  margin: 5px;
}

.approve-btn {
  background-color: #009906;
  border: none;
}

.reject-btn {
  background-color: #e20000;
  border: none;
}

.report-btn {
  background-color: #fd881e;
  border: none;
}

.input-datetime {
  width: 108px;
  margin-left: 5px;
  margin-right: 5px;
}

.in-ranges {
  background: #a5ffa7;
}

.not-in-ranges {
  background: #f4ab00;
}

.history-table {
  tr {
    td {
      text-align: center;
    }
  }
}
.order-date {
  display: flex;
  align-items: center;
}
</style>
